import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility.js";
import usbService from "../js/usb-services.js";
import commonAPIService from "../../common/js/common-api-service";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    dropLPN: false,
    lpnDrop: "",
    actionList: [],
    mainPage: "",
    favouriteList: [],
    pageUrl: "",
    subPage: "",
    showAdd: false,
    subPageUrl: "",
    backSlash: true,
    backSlashParent: true,
    showRefreshDialog: true,
    showStartSourcing: true,
    sourcingStarted: false,
    showStopSourcing: false,
    usbLPNText: "",
    usbLPNQuantity: "",
    usbLPNNum: "",
    usbLPNStatus: false,
    lineId: "",
    workflowCode: "",
    startSourcing: "",
    sourceConfigData: [],
    hideStartSourcingCard: true,
    soKey: 0,
    showSourcingDetails: false,
    rowBtnData: [],
    partBtnData: [],
    rowSelected: [],
    partSelected: [],
    sourceConfPartsCheckData: [],
    showQuantity: false,
    targetInTransitLPN: "",
    showLPN: false,
    disableLPN: false,
    disableUnitIdent: false,
    sourceActionDialog: false,
    errorSource: "",
    binDataBtn: [],
    required: [(v) => !!v || "Unit Identifier is required"],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.mainPage = data?.mainPage;
    this.favouriteList = data?.favouriteList;
    this.pageUrl = data?.pageUrl;
    this.subPage = data?.subPage;
    this.showAdd = data?.showAdd;
    this.subPageUrl = data?.subPageUrl;
    this.appPageName = data?.appPageName;
    let actionData = await AddFavourite.getParentPageAction(this.userId, this.subPageUrl);
    this.actionList = actionData?.actionList;
    if (this.$route.params.lineId !== undefined && this.$route.params.workflowCode !== undefined && this.$route.params.startSourcing) {
      this.lineId = atob(this.$route.params.lineId);
      this.workflowCode = atob(this.$route.params.workflowCode);
      this.startSourcing = atob(this.$route.params.startSourcing);
    } else {
      this.$router.push(`/usb-source-configuration`);
    }
    this.sourceWorkflow();
    this.sourcingLPNStatus();
    if (this.startSourcing == "start") {
      this.onClickStartSourcing();
    }
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.sourceConfigData = [];
      this.hideStartSourcingCard = true;
      this.soKey = 0;
      this.showSourcingDetails = false;
      this.rowBtnData = [];
      this.rowSelected = [];
      this.partBtnData = [];
      this.partSelected = [];
      this.sourceConfPartsCheckData = [];
      this.showQuantity = false;
      this.showLPN = false;
      this.targetInTransitLPN = "";
      this.disableLPN = false;
      this.disableUnitIdent = false;
      this.sourceActionDialog = false;
      this.errorSource = "";
      this.targetInTransitLPN = "";
      this.sourcingStarted = false;
      this.binDataBtn = [];
      this.sourceWorkflow();
      this.sourcingLPNStatus();
      if (this.startSourcing == "start") {
        this.onClickStartSourcing();
      }
    },
    //LPN Status
    async sourcingLPNStatus() {
      let data = await usbService.sourcingLPNStatus("get", this.userId);
      if (data.message !== "NA") {
        this.lpnData = data;
        this.usbLPNDrop = "";
        if (this.lpnData[0].LPN !== "") {
          this.usbLPNStatus = true;
          this.usbLPNText = this.lpnData[0].LPN;
          this.usbLPNQuantity = this.lpnData[0].lpn_qty;
          this.usbLPNNum = this.lpnData[0].LPN;
        } else {
          this.usbLPNStatus = true;
          this.usbLPNText = "NO LPNS ASSIGNED";
          this.usbLPNQuantity = 0;
          this.usbLPNNum = "";
        }
      }
    },
    //Source Workflow default
    async sourceWorkflow() {
      let obj = {
        user_id: parseInt(this.userId),
        line_id: parseInt(this.lineId),
        workflowcode: this.workflowCode,
      };
      let data = await usbService.sourceConfigHeaderData("post", obj);
      if (data.message !== "NA") {
        const newArr = data.map((obj) => {
          return {
            ...obj,
            stage_date: Utility.displayDateFormat(obj.stage_date),
          };
        });
        this.sourceConfigData = [];
        this.sourceConfigData = newArr;
        if (this.sourceConfigData[0]?.cansource == "1") {
          this.showStartSourcing = false;
          this.sourcingStarted = false;
        } else {
          this.showStartSourcing = true;
          this.sourcingStarted = true;
        }
      }
    },
    //Start Sourcing To Begin
    async onClickStartSourcing() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("usb/sourcing_configuration_start?user_key=" + this.userId + "&line_id=" + this.lineId + "&workflowcode=" + this.workflowCode)
        .then((response) => {
          if (response.status == 200) {
            this.hideStartSourcingCard = false;
            this.showStartSourcing = false;
            this.sourcingStarted = false;
            this.showStopSourcing = true;
            this.getSourcingConfigRows();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get Sourcing Configuration headers
    async getSourcingConfigRows() {
      this.rowBtnData = [];
      let data = await usbService.getSourcingConfigRows("get", this.userId, this.soKey, this.workflowCode, this.lineId);
      if (data.message !== "NA") {
        this.rowBtnData = data;
        this.showSourcingDetails = true;
      }
    },
    //Row button on click event
    async rowBtnClick(rowId) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.rowSelected = [];
      this.partBtnData = [];
      this.rowSelected = this.rowBtnData.filter((obj) => obj.row_id == rowId);
      this.rowBtnData = this.rowBtnData.filter((obj) => obj.row_id == rowId);
      let obj = {
        user_id: parseInt(this.userId),
        line_id: parseInt(this.lineId),
        workflowcode: this.workflowCode,
        so_key: 0,
        row_id: rowId,
      };
      this.axios
        .post("/usb/sourcing_configuration_parts_by_row", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (response.data.body.message !== "") {
              let data = JSON.parse(response.data.body.message);
              this.partBtnData = data;
              this.partBinData();
            } else {
              this.rowSelected = [];
              this.onClickStartSourcing();
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    partBinData() {
      this.binDataBtn = [];
      this.binDataBtn = this.partBtnData[0]?.bins?.split(",").map((item) => item.trim());
    },
    //Part button click event
    async partBtnClick(partKey) {
      this.sourceConfPartsCheckData = [];
      this.partSelected = [];
      this.partSelected = this.partBtnData.filter((obj) => obj.part_key == partKey);
      this.partBtnData = this.partBtnData.filter((obj) => obj.part_key == partKey);
      let obj = {
        user_id: parseInt(this.userId),
        so_id: 0,
        part_key: partKey,
        row_id: this.rowSelected[0]?.row_id,
        line_id: parseInt(this.lineId),
      };
      let data = await usbService.sourceConfigPartsCheck("post", obj);
      if (data.message !== "NA") {
        this.sourceConfPartsCheckData = data;
      }
    },
    //Stop Sourcing To Begin
    async onClickStopSourcing() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("usb/sourcing_configuration_exit?user_id=" + this.userId + "&line_id=" + this.lineId + "&workflowcode=" + this.workflowCode)
        .then((response) => {
          if (response.status == 200) {
            let Alert = {
              type: "success",
              isShow: true,
              message: "USB Source Configuration has been successfully exited",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.$router.push(`/usb-source-configuration`);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Hand Shake call
    handshakeCall() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("usb/sourcing_configuration_take?user_id=" + this.userId + "&line_id=" + this.lineId + "&workflowcode=" + this.workflowCode)
        .then((response) => {
          if (response.status == 200) {
            this.sourceWorkflow();
            this.hideStartSourcingCard = false;
            this.showStartSourcing = false;
            this.sourcingStarted = false;
            this.showStopSourcing = true;
            this.getSourcingConfigRows();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Change in Unit identifier
    changeUnitIdentifier() {
      if (this.$refs.unitIdentifierForm.validate()) {
        this.disableUnitIdent = true;
        this.showQuantity = true;
        this.showLPN = true;
        this.unitQuantity = this.sourceConfPartsCheckData[0].QtyToPick;
        if (this.usbLPNText !== "NO LPNS ASSIGNED") {
          this.targetInTransitLPN = this.usbLPNText;
          this.disableLPN = true;
        }
        if (this.sourceConfigData[0]?.user_lpn !== "") {
          this.targetInTransitLPN = this.sourceConfigData[0]?.user_lpn;
          this.disableLPN = true;
        }
      }
    },
    //to check if its a number with hyphen of not
    usbLPNNumFormat(event, num) {
      this.targetInTransitLPN = Utility.formatLPNNumber(event, num);
    },
    //Get next available LPN number
    async getLPNNumber() {
      let lpnData = await commonAPIService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.targetInTransitLPN = lpnData[0]?.lpn;
        this.disableLPN = true;
      }
    },
    //Sumit call
    submitSourcing() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        so_id: this.sourceConfigData[0]?.so_id,
        line_id: this.sourceConfigData[0]?.line_id,
        part_id: 0,
        bin_id: 0,
        lpn_key: 0,
        to_lpn: this.targetInTransitLPN,
        qty: this.unitQuantity,
        unit_identifier: this.unitIdentifier,
        workflowcode: this.workflowCode,
      };
      this.axios
        .post("/usb/sourcing_configuration_submit", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.$router.push(`/usb-source-configuration`);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          this.sourceActionDialog = true;
          this.errorSource = error.response.data.message;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.errorMessage = error.message;
        });
    },
    //Close Source Action
    closeSourceAction() {
      this.sourceActionDialog = false;
      this.unitIdentifier = "";
      this.disableUnitIdent = false;
      this.unitQuantity = "";
      this.showQuantity = false;
      this.targetInTransitLPN = "";
      this.disableLPN = false;
      this.showLPN = false;
    },
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
